import { PrinterPosStopIcon } from './PrinterPosStopIcon';

/**
 * author: Colton Wiscombe
 * id 8DE1FE3F-D679-44B4-AECA-7A9B5F0CC2A7
 * name printer-pos-stop
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-stop.svg
 * tags
 * - Printer 
 */
export const PrinterReceiptStopIcon = PrinterPosStopIcon;
export default PrinterReceiptStopIcon